// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__1yiCY","icon":"SearchBar_icon__h7BmA","textInput":"SearchBar_textInput__M9kUB","clearButton":"SearchBar_clearButton__er4M5"};